/**
 * Illustrative data for the public sample report. Every number here is made
 * up to show the report's shape; none is a real candidate, norm or benchmark.
 * The page must never send this to analytics or the API.
 */
export const sampleCandidate = {
  uuid: null,
  firstName: 'Sample',
  surname: 'Candidate',
  email: 'sample@example.com',
  attempts: []
}

const attempt = (overrides) => ({
  attemptId: null,
  candidateId: null,
  jobId: null,
  examType: 'aptitude',
  scores: null,
  result: null,
  usedUnlimitedTime: false,
  usedExtraTime: false,
  leaveAssessmentWindowCount: 0,
  hasExitedFullScreen: false,
  ipAddressChanged: null,
  webcam: null,
  unlockedAt: '2026-09-01T09:00:00Z',
  createdAt: '2026-09-01T08:30:00Z',
  ...overrides
})

export const sampleAssessmentName = 'Finance assistant (QuickBooks)'

export const sampleExams = [
  {
    slug: 'quickbooks-114e8e',
    name: 'QuickBooks',
    level: 'Software skills',
    icon: 'presentation-chart-bar',
    minutes: 10,
    attempt: attempt({
      examSlug: 'quickbooks-114e8e',
      examName: 'QuickBooks',
      scorePercentage: 75,
      questionsAnswered: 12,
      questionsCorrect: 9,
      questionsTotal: 12,
      speedCompleted: 460,
      percentageBand: 'high',
      bracket: 'Above average (sample)'
    })
  },
  {
    slug: 'numerical-reasoning-71195',
    name: 'Numerical Reasoning',
    level: 'Aptitude',
    icon: 'calculator',
    minutes: 10,
    attempt: attempt({
      examSlug: 'numerical-reasoning-71195',
      examName: 'Numerical Reasoning',
      scorePercentage: 56,
      questionsAnswered: 9,
      questionsCorrect: 5,
      questionsTotal: 9,
      speedCompleted: 590,
      percentageBand: 'medium',
      bracket: 'Average (sample)'
    })
  },
  {
    slug: 'microsoft-excel-3d10b',
    name: 'Microsoft Excel',
    level: 'Software skills',
    icon: 'view-grid',
    minutes: 10,
    attempt: attempt({
      examSlug: 'microsoft-excel-3d10b',
      examName: 'Microsoft Excel',
      scorePercentage: 81,
      questionsAnswered: 16,
      questionsCorrect: 13,
      questionsTotal: 16,
      speedCompleted: 505,
      percentageBand: 'high',
      bracket: 'Above average (sample)'
    })
  },
  {
    slug: 'error-checking-2022-9cf5f',
    name: 'Error Checking',
    level: 'Aptitude',
    icon: 'clipboard-check',
    minutes: 10,
    attempt: attempt({
      examSlug: 'error-checking-2022-9cf5f',
      examName: 'Error Checking',
      scorePercentage: 64,
      questionsAnswered: 26,
      questionsCorrect: 18,
      questionsTotal: 28,
      speedCompleted: 600,
      percentageBand: 'medium',
      bracket: 'Average (sample)'
    })
  }
]

/**
 * What a real, unlocked report adds for each test beyond the score card.
 */
export const realReportAdds = [
  'A written summary for the score band, with the points that summary is based on.',
  'The candidate’s score placed against the average and spread of other people who took the same test, when that data exists for the test. Where it does not, the report says so instead of inventing a comparison.',
  'Browser observations for the sitting, reported as observations with unknown coverage, never as proof of cheating.',
  'Detailed answer review for library tests, showing each question and the answer given.'
]
